import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import withOptions from 'utils/functions/withOptions.util';
import isDigit from 'utils/predicates/number/isDigit.util';

const DEFAULT_LENGTH = 6;

const join = (raw) => raw.map(fromAnyToString).join('');

const parseCode = withOptions(({ value: raw, length = DEFAULT_LENGTH }) => {
  const array = Array.isArray(raw);
  const empty = !(array && raw.length > 0 && join(raw));

  // TODO: make it work for anything, not just Array
  if (empty || !array) return { string: '', raw, is: { empty, array, valid: false } };

  const valid = array ? raw.every(isDigit) && raw.length === length : false;
  const string = array ? join(raw) : fromAnyToTrimmed(raw);

  const is = { empty, array, valid };

  return { string, raw, is };
});

export default parseCode;
